<template>
  <div class="grid-list">
    <div
      class="
        primary--text
        text--lighten-1 text-body-1 text-center
        font-weight-regular
      "
    >
      Área do Terreno
    </div>
    <v-sheet
      v-if="loading"
      class="d-flex justify-center align-center"
      height="100%"
      width="100%"
      color="transparent"
    >
      <v-progress-circular
        :size="20"
        color="primary"
        indeterminate
      ></v-progress-circular>
    </v-sheet>

    <div v-else class="mt-n1">
      <v-range-slider
        class="align-center"
        v-model="range"
        :max="max"
        :min="min"
        :step="$route.path === '/rural' ? 1 : 50"
        hide-details="hide-details"
      />

      <input name="total-area-min" :value="rangeStart" type="hidden" />
      <input name="total-area-max" :value="rangeEnd" type="hidden" />

      <div class="d-flex justify-space-between px-2 mt-n1">
        <div
          class="primary--text text--lighten-1 text-body-2 font-weight-medium"
        >
          {{
            formatArea(
              rangeStart,
              $route.path === "/rural" ? " hectares" : " m²"
            )
          }}
        </div>
        <div
          class="primary--text text--lighten-1 text-body-2 font-weight-medium"
        >
          {{
            formatArea(rangeEnd, $route.path === "/rural" ? " hectares" : " m²")
          }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { formatArea } from "../../../utils/formatArea";

const _data = {
  loading: true,
  rangeStart: 0,
  rangeEnd: 0,
  max: 0,
};

export default {
  data: () => ({
    ..._data,
  }),
  computed: {
    items() {
      return this.$rest("properties").list;
    },
    price() {
      return this.$route.query.preco.split(",");
    },
    min() {
      return 0;
    },
    range: {
      get() {
        return [this.rangeStart, this.rangeEnd];
      },
      set(v) {
        this.rangeStart = v[0];
        this.rangeEnd = v[1];
      },
    },
  },
  methods: {
    getMax() {
      this.loading = true;

      const params = {
        itemsPerPage: 1,
        returnTotalArea: 1,
      };

      if (this.$route.query.tipo) params.category = this.$route.query.tipo;
      else if (this.$route.path === "/terrenos")
        params.category = "Terreno, Terreno Comercial";
      else if (this.$route.path === "/rural")
        params.category = "Área,Chácara,Fazenda,Sítio";

      this.$rest("properties")
        .get({ params })
        .then((data) => {
          this.max =
            data[0].total_area * (this.$route.path === "/rural" ? 0.0001 : 1) +
            (this.$route.path === "/rural" ? 1 : 50);
          if (this.max > this.rangeEnd && !this.$route.query.preco)
            this.rangeEnd =
              data[0].total_area *
                (this.$route.path === "/rural" ? 0.0001 : 1) +
              (this.$route.path === "/rural" ? 1 : 50);
        })
        .finally(() => (this.loading = false));
    },
    formatArea,
  },
  watch: {
    max(v) {
      if (!this.rangeEnd) this.rangeEnd = v;
    },
    min(v) {
      if (!this.rangeStart) this.rangeStart = v;
    },
    "$route.path"() {
      this.getMax();
    },
  },
  created() {
    this.getMax();
  },
};
</script>

<style lang="scss" scoped>
.grid-list {
  display: grid;
  grid-template-columns: 1fr;
}
</style>
